const LOCK_PREFIX = 'delivery-video-call-accept-lock';
const LOCK_TTL_MS = 5000;
const LOCK_SETTLE_MS = 75;

export const deliveryVideoCallTabLockKey = (pharmacyId, callId) => (
  `${LOCK_PREFIX}:${String(pharmacyId ?? '')}:${String(callId ?? '')}`
);

const readLock = (storage, key) => {
  try {
    const value = storage?.getItem?.(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    return null;
  }
};

const waitForOtherTabs = (delayMs) => new Promise((resolve) => {
  window.setTimeout(resolve, delayMs);
});

export async function claimDeliveryVideoCallTabLock({
  pharmacyId,
  callId,
  tabId,
  storage = window.localStorage,
  now = () => Date.now(),
  wait = waitForOtherTabs,
} = {}) {
  if (!callId || !tabId || !storage) {
    return true;
  }

  const key = deliveryVideoCallTabLockKey(pharmacyId, callId);
  const timestamp = now();
  const existing = readLock(storage, key);
  if (existing?.expiresAt > timestamp && existing?.tabId !== tabId) {
    return false;
  }

  const lock = { tabId, expiresAt: timestamp + LOCK_TTL_MS };
  try {
    storage.setItem(key, JSON.stringify(lock));
    await wait(LOCK_SETTLE_MS);
  } catch (error) {
    return true;
  }

  const confirmed = readLock(storage, key);
  return confirmed?.tabId === tabId && confirmed?.expiresAt > now();
}

export function releaseDeliveryVideoCallTabLock({
  pharmacyId,
  callId,
  tabId,
  storage = window.localStorage,
} = {}) {
  if (!callId || !tabId || !storage) {
    return;
  }

  const key = deliveryVideoCallTabLockKey(pharmacyId, callId);
  if (readLock(storage, key)?.tabId !== tabId) {
    return;
  }

  try {
    storage.removeItem(key);
  } catch (error) {}
}
